import { connect } from 'react-redux';
import {
  updateVerify,
  updateReviewed,
  updateUserFlag,
  updateOverrideSystemFlag,
  updateComfortAssignAnnotation,
} from 'store/actions/element-panel-actions';
import ElementStatus from 'components/feature/element-panel/element-status-component';
import {
  getElementTickmarksAndUpdateElementCache,
  attachTickmarkToElement,
} from 'store/actions/element-panel-actions';
import { fetchTickmarkListForRevisionWithoutLoading } from 'store/actions/common/tickmark-list-panel-actions';

const mapStateToProps = ({
  data: {
    revision,
    currentUser,
    elementPanel: { elementDetails, elementHistory },
  },
  ui: {
    statementPage: {
      panels: { left },
    },
  },
}) => ({
  elementDetails,
  elementHistory,
  currentUser,
  leftPanel: left,
});
const mapDispatchToProps = {
  updateVerify,
  updateReviewed,
  updateUserFlag,
  updateOverrideSystemFlag,
  updateComfortAssignAnnotation,
  onCreateTickmark: getElementTickmarksAndUpdateElementCache,
  onAttachTickmark: attachTickmarkToElement,
  fetchTickmarkList: fetchTickmarkListForRevisionWithoutLoading,
};
export default connect(mapStateToProps, mapDispatchToProps)(ElementStatus);
